module.exports = wp.editor;